import React from "react";
import { Toolbar } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Refresh from "@mui/icons-material/Refresh";
import { useTheme } from "@mui/material/styles";
import { useTenantTranslation } from "hooks/formatters";
import { useFileExplorerContext } from "../FileExplorerContext";

export const FileExplorerToolbar: React.FC = () => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  const { isLoading, isRefreshing, onRefresh } = useFileExplorerContext();

  return (
    <Toolbar sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}>
      <LoadingButton
        variant="outlined"
        startIcon={<Refresh />}
        onClick={() => void onRefresh()}
        loading={isRefreshing}
        disabled={isLoading}
        sx={{ mr: 2 }}
      >
        {t("refresh")}
      </LoadingButton>
    </Toolbar>
  );
};
